export default __webpack_public_path__ + "static/media/floor-location-icon.a326fa5d.svg";